import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

const MediaLinkLogo = () => (
  <StaticQuery
    query={graphql`
      query {
        medialogo_accj: file(
          relativePath: { eq: "media-logo/medialogo_accj.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 199, maxHeight: 79) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        medialogo_cnet: file(
          relativePath: { eq: "media-logo/medialogo_cnet.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 199, maxHeight: 79) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        medialogo_forbes: file(
          relativePath: { eq: "media-logo/medialogo_forbes.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 199, maxHeight: 79) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        medialogo_gendai: file(
          relativePath: { eq: "media-logo/medialogo_gendai.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 199, maxHeight: 79) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        medialogo_president: file(
          relativePath: { eq: "media-logo/medialogo_president.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 199, maxHeight: 79) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        medialogo_prtimes: file(
          relativePath: { eq: "media-logo/medialogo_prtimes.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 199, maxHeight: 79) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        medialogo_sankei: file(
          relativePath: { eq: "media-logo/medialogo_sankei.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 199, maxHeight: 79) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        medialogo_thebridge: file(
          relativePath: { eq: "media-logo/medialogo_thebridge.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 199, maxHeight: 79) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        medialogo_toyokeizai: file(
          relativePath: { eq: "media-logo/medialogo_toyokeizai.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 199, maxHeight: 79) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        medialogo_yahoo: file(
          relativePath: { eq: "media-logo/medialogo_yahoo.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 199, maxHeight: 79) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={(data) => (
      <div className="row mx-0 home-media">
        <div className="container-fluid max-1100 pr-0 pl-0">
          <div className="col-12 home-media-title text-center">
            <span className="text-green-">メディア掲載</span>
          </div>
          <div className="row media-logo-list">
            <div className="media-logo">
              <a
                href="https://www.sankei.com/economy/news/190225/prl1902250221-n1.html"
                target="_blank"
                rel="noopener noreferrer">
                <Img fluid={data.medialogo_sankei.childImageSharp.fluid} />
              </a>
            </div>
            <div className="media-logo">
              <a
                href="http://gendai.ismedia.jp/ud/pressrelease/5c737aab7765616242100000"
                target="_blank"
                rel="noopener noreferrer">
                {/* <img className="img-fluid" src={gendai} alt="" /> */}
                <Img fluid={data.medialogo_gendai.childImageSharp.fluid} />
              </a>
            </div>

            <div className="media-logo">
              <a
                href="http://president.jp/ud/pressrelease/5c737a037765618570100000"
                target="_blank"
                rel="noopener noreferrer">
                {/* <img className="img-fluid" src={president} alt="" /> */}
                <Img fluid={data.medialogo_president.childImageSharp.fluid} />
              </a>
            </div>
            <div className="media-logo">
              <a
                href="https://headlines.yahoo.co.jp/article?a=20190302-00025789-forbes-bus_all"
                target="_blank"
                rel="noopener noreferrer">
                {/* <img className="img-fluid" src={yahoo} alt="" /> */}
                <Img fluid={data.medialogo_yahoo.childImageSharp.fluid} />
              </a>
            </div>
            <div className="media-logo">
              <a
                href="https://japan.cnet.com/release/30299987/"
                target="_blank"
                rel="noopener noreferrer">
                {/* <img className="img-fluid" src={cnet} alt="" /> */}
                <Img fluid={data.medialogo_cnet.childImageSharp.fluid} />
              </a>
            </div>
            <div className="media-logo">
              <a
                href="http://toyokeizai.net/ud/pressrelease/5c737a6c7765613fb10f0000"
                target="_blank"
                rel="noopener noreferrer">
                {/* <img className="img-fluid" src={toyokeizai} alt="" /> */}
                <Img fluid={data.medialogo_toyokeizai.childImageSharp.fluid} />
              </a>
            </div>
            <div className="media-logo">
              <a
                href="https://prtimes.jp/main/html/rd/p/000000003.000035738.html"
                target="_blank"
                rel="noopener noreferrer">
                {/* <img className="img-fluid" src={prtimes} alt="" /> */}
                <Img fluid={data.medialogo_prtimes.childImageSharp.fluid} />
              </a>
            </div>
            <div className="media-logo">
              <a
                href="https://forbesjapan.com/articles/detail/25789/"
                target="_blank"
                rel="noopener noreferrer">
                {/* <img className="img-fluid" src={forbes} alt="" /> */}
                <Img fluid={data.medialogo_forbes.childImageSharp.fluid} />
              </a>
            </div>
            <div className="media-logo">
              <a
                href="https://journal.accj.or.jp/change-agent/"
                target="_blank"
                rel="noopener noreferrer">
                {/* <img className="img-fluid" src={accj} alt="" /> */}
                <Img fluid={data.medialogo_accj.childImageSharp.fluid} />
              </a>
            </div>
            <div className="media-logo">
              <a
                href="https://thebridge.jp/prtimes/309483"
                target="_blank"
                rel="noopener noreferrer">
                {/* <img className="img-fluid" src={thebridge} alt="" /> */}
                <Img fluid={data.medialogo_thebridge.childImageSharp.fluid} />
              </a>
            </div>
          </div>
        </div>
      </div>
    )}
  />
);

export default MediaLinkLogo;
